<template>
  <el-collapse-item title="Professional Fee" name="11">
    <template slot="title">
      <el-col :span="12" style="padding-left: 0px;">
        Professional Fee
      </el-col>
      <el-col :span="12" style="text-align: right; padding: 0px 15px 0px 0px;">
        {{(this.getProRecordsCount()) > 0 ? ''+(this.getProRecordsCount())+' Records' : ''}}
      </el-col>
    </template>
    <el-col class="collapseContentLeft" :span="7">
      <span>HIA will validate:</span>
      <ul class="hiaValidation proValidations">
        <li v-for="item in getReviewValidations('PRO')" :key="item.id">{{item.description}}</li>
      </ul>
      <el-button :disabled="!getProRecordsCount() || !canClearRecords" plain style="margin: 15px 0px 0px 0px;" @click="clearProEmit()">
        Clear Records <i style="padding-left: 5px;" class="mdi mdi-book-multiple-minus reviewIcon"></i>
      </el-button>
    </el-col>
    <el-col class="collapseContentLeft" :span="17">
      <el-form label-position="top" ref="otherRecords">
        <el-row>
          <el-col style="padding-right: 10px;" :span="24">
            <el-form-item label="Records Selected By:">
              <input type="radio" name="profeeByProvider" :value="true" v-model="profeeByProviderComputed" @change="handleByProviderChange">Provider/Specialty
              <input type="radio" name="profeeByProvider" :value="false" v-model="profeeByProviderComputed" @change="handleByProviderChange">Coder
            </el-form-item>

            <el-row v-if="!reviewRequest.profeeByProvider" style="margin: 15px 0px 0px 5px;">
              <el-col :span="14">
                <strong>Assign Records</strong>
                <el-form-item label="Number of Coders:">
                  <el-input-number size="mini" v-model="byCoderComputed.numProviders" @change="saveSpecialties([byCoderComputed])" :min="0">
                  </el-input-number>
                </el-form-item>
                <el-form-item label="Number of E&M Accounts Per Coder:">
                  <el-input-number size="mini" v-model="byCoderComputed.numEM" @change="saveSpecialties([byCoderComputed])" :min="0">
                  </el-input-number>
                </el-form-item>
                <el-form-item label="Number of CPT Accounts Per Coder:">
                  <el-input-number size="mini" v-model="byCoderComputed.numCPT" @change="saveSpecialties([byCoderComputed])" :min="0">
                  </el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <strong>Place of Service</strong>
                <div>
                  <input type="checkbox" @change="saveSpecialties([byCoderComputed])" v-model="byCoderComputed.isHospital">Hospital
                </div>
                <div style="padding-bottom: 15px;">
                  <input type="checkbox" @change="saveSpecialties([byCoderComputed])" v-model="byCoderComputed.isClinic">Clinic
                </div>
                <el-form-item label="Other Instructions" class="otherInstructions">
                  <el-input type="textarea" :rows="4" placeholder="Other Instructions" v-model="byCoderComputed.otherInstructions" @change="saveSpecialties([byCoderComputed])">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-button v-if="reviewRequest.profeeByProvider" style=" margin: 20px 0px 15px 0px;" icon="el-icon-plus" plain @click="openSpecialtiesModal()">
              Add/Update Specialties
            </el-button>
            <el-table v-if="reviewRequest.profeeByProvider" id="proRecordConfirmTable" ref="proRecordConfirmTable" class="top-margin" :data="reviewRequest.proRecords.records">
              <el-table-column label="Specialty" width="180">
                <template slot-scope="scope">
                  <span>{{ specialties.find(x => x.id === scope.row.specialtyId).specialty }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Providers">
                <template slot-scope="scope">
                  <span>{{ scope.row.numProviders }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Details">
                <template slot-scope="scope">
                  <span v-html="getProRecordConfirmDetails(scope.row)"></span>
                </template>
              </el-table-column>
              <el-table-column label="Other Instructions">
                <template slot-scope="scope">
                  <span class="breakWord" v-html="scope.row.otherInstructions"></span>
                </template>
              </el-table-column>
              <el-table-column label="Total Records">
                <template slot-scope="scope">
                  <span>{{ getProRecordConfirmRecords(scope.row) }}</span>
                </template>
              </el-table-column>
              <template slot="empty">
                <p> No Professional Fee Records</p>
              </template>
            </el-table>
            <p class="totalRecords">Total Records: {{getProRecordsCount()}}</p>
          </el-col>
        </el-row>
        <el-row>
          <el-col style="padding: 10px 10px 0px 0px;" :span="24">
            <el-form-item label="Please explain if any of these charts will include procedures or if you have special instructions:">
              <el-input type="textarea" :rows="4" placeholder="Instructions" v-model="proRecords.instructions" @change="putProDemo()">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <ReviewRequestProSpecialtiesModal :specialties="addSpecialties.filter(x => x.specialty !== 'By Coder')" :showSpecialtiesModal="showSpecialtiesModal" @apply="saveAndCloseSpecialtiesModal" @cancel="cancelSpecialtiesModalSave()">
        </ReviewRequestProSpecialtiesModal>
      </el-form>
    </el-col>
  </el-collapse-item>
</template>
<script>
  import { mapState } from 'vuex'
  import ReviewRequestProSpecialtiesModal from './ReviewRequestProSpecialtiesModal'

  export default {
    props: {
      loading: {
        type: Boolean
      },
      addRecords: {
        type: Object
      },
      reviewRequest: {
        type: Object
      },
      isEditRoute: {
        type: Boolean,
        default: false
      },
      canClearRecords: {
        type: Boolean,
        default: true
      },
      remainingRecordsWithoutPro: {
        type: Number,
        default: 0
      }
    },
    data: function () {
      return {
        showSpecialtiesModal: false,
        addSpecialties: [],
        specialtiesBackup: [],
        proRecords: {
          type: 'pro',
          title: 'Professional Fee',
          instructions: '',
          records: []
        }
      }
    },
    name: 'ReviewRequestProRecordDetails',
    methods: {
      handleByProviderChange() {
        const proCount = this.getProRecordsCount()
        if (this.isEditRoute && proCount > 0 && this.remainingRecordsWithoutPro <= 0) {
          this.$message({
            type: 'error',
            message: 'A review request must have at least one record selected.',
            duration: 5000
          })
          this.$forceUpdate()
          return
        }
        if (this.reviewRequest.proRecords.records.length > 0) {
          this.$confirm(`This will clear previously selected specialties?`, 'Warning', {
            confirmButtonText: 'Continue',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }).then(() => {
            this.reviewRequest.profeeByProvider = !this.reviewRequest.profeeByProvider
            this.addSpecialties = this.addSpecialties.map(x => {
              x.selected = false
              return x
            })
            this.$emit('toggleProSelectedBy')
          }).catch(() => {
            this.$forceUpdate()
          })
        } else {
          // no confirm modal needed
          this.reviewRequest.profeeByProvider = !this.reviewRequest.profeeByProvider
          this.$emit('toggleProSelectedBy')
        }
      },
      clearProEmit() {
        if (!this.canClearRecords) {
          this.$message({
            type: 'error',
            message: 'A review request must have at least one record selected.',
            duration: 5000
          })
          return
        }
        this.$emit('clearPro', {})
      },
      clearPro() {
        this.setAddRowSpecialties()
        this.specialtiesBackup = JSON.parse(JSON.stringify(this.addSpecialties))
      },
      putProDemo() {
        this.$emit('addProRecords', { proRecords: this.proRecords })
      },
      getReviewValidations(type) {
        return this.reviewValidations.filter(x => x.patientType === type)
      },
      openSpecialtiesModal() {
        this.specialtiesBackup = JSON.parse(JSON.stringify(this.addSpecialties))
        this.showSpecialtiesModal = true
      },
      cancelSpecialtiesModalSave() {
        this.addSpecialties = this.specialtiesBackup
        this.showSpecialtiesModal = false
      },
      setAddRowSpecialties() {
        this.addSpecialties = []
        this.addSpecialties = this.specialties.map(x => {
          let item = {
            selected: false,
            specialty: x.specialty,
            specialtyId: x.id,
            isClinic: false,
            isHospital: false,
            numProviders: 0,
            numEM: 0,
            numCPT: 0,
            id: 0,
            otherInstructions: null
          }
          return item
        })
      },
      saveAndCloseSpecialtiesModal(payload) {
        this.showSpecialtiesModal = false
        this.saveSpecialties(payload)
      },
      saveSpecialties(payload) {
        let newProCount = 0
        for (let i = 0; i < payload.length; i++) {
          const item = payload[i]
          newProCount += (item.numProviders * item.numEM) + (item.numProviders * item.numCPT)
        }
        if (this.isEditRoute && this.remainingRecordsWithoutPro + newProCount <= 0) {
          this.$message({
            type: 'error',
            message: 'A review request must have at least one record selected.',
            duration: 5000
          })
          return
        }
        this.proRecords.records = payload
        this.$emit('addProRecords', { proRecords: this.proRecords })
      },
      getProRecordsCount() {
        let length = this.reviewRequest.proRecords.records.length
        let proRecordsCount = 0
        let item
        if (length > 0) {
          for (let i = 0; i < length; i++) {
            item = this.reviewRequest.proRecords.records[i]
            proRecordsCount += (item.numProviders * item.numEM) + (item.numProviders * item.numCPT)
          }
        }
        return proRecordsCount
      },
      getProRecordConfirmRecords(row) {
        return (row.numProviders * row.numEM) + (row.numProviders * row.numCPT)
      },
      getProRecordConfirmDetails(row) {
        let optionText = []
        let placeService = []

        if (row.numEM) {
          optionText.push(`EM: ${(row.numEM)}`)
        }
        if (row.numCPT) {
          optionText.push(`CPT: ${(row.numCPT)}`)
        }

        if (row.isClinic) {
          placeService.push('Clinic')
        }
        if (row.isHospital) {
          placeService.push('Hospital')
        }

        return placeService.length ? `${optionText.join(', ')} <br /> ${placeService.join(', ')} ` : `${optionText.join(', ')} `
      },
      recordCheck() {
        if (this.addRecords.proRecords.records.length) {
          this.proRecords = this.addRecords.proRecords
          this.setAddRowSpecialties()
          this.specialtiesCheck()
        }
      },
      specialtiesCheck() {
        let length = this.addRecords.proRecords.records.length
        let index
        for (let i = 0; i < length; i++) {
          index = this.addSpecialties.findIndex(x => x.specialtyId === this.addRecords.proRecords.records[i].specialtyId)
          this.addRecords.proRecords.records[i].selected = true
          this.addRecords.proRecords.records[i].specialty = this.addSpecialties[index].specialty
          let item = Object.assign({}, this.addRecords.proRecords.records[i])
          this.addSpecialties.splice(index, 1, item)
        }
      }
    },
    components: {
      ReviewRequestProSpecialtiesModal
    },
    computed: {
      ...mapState('requests/reviews', ['reviewValidations']),
      ...mapState('requests/', ['specialties']),
      profeeByProviderComputed: {
        get() {
          return this.reviewRequest.profeeByProvider
        },
        set(val) {
          // do nothing, setter is handled by change event
        }
      },
      byCoderComputed() {
        let specialtyId = this.specialties.find(x => x.specialty === 'By Coder').id
        let existingRow = this.reviewRequest.proRecords.records.find(x => x.specialtyId === specialtyId)
        if (existingRow) {
          return existingRow
        }

        return {
          numCPT: 0,
          numEM: 0,
          numProviders: 0,
          specialtyId: specialtyId,
          isHospital: false,
          isClinic: false,
          instructions: null,
          id: 0
        }
      }
    },
    created() {
      this.setAddRowSpecialties()
      this.recordCheck()
    }
  }
</script>
<style scoped>
.proValidations {
  height: 200px;
  overflow-y: scroll;
}

.hiaValidation {
  margin: 0px 0px 0px 0px;
  padding: 2px 5px 2px 5px;
  border: 1px solid rgba(238, 238, 238, 1);
  border-radius: 10px;
  background: rgba(238, 238, 238, 0.5);
}

.hiaValidation li {
  list-style-type: none;
}

.reviewHeading {
  margin: 12px 0px 0px 0px;
  border-bottom: 1px solid #c0c4cc;
  padding-bottom: 10px;
  line-height: 0;
}

.contentSpacing {
  margin: 0px 0px 0px 0px !important;
  padding: 0px 0px 0px 0px !important;
}

.collapseContentLeft {
  padding: 5px 0px 8px 10px !important;
}

.collapseContentRight {
  padding: 5px 10px 8px 10px !important;
}

.reviewIcon {
  font-size: 17px;
  float: left;
  height: 12px;
  margin: -3px 5px 0px 0px;
}

.totalRecords {
  font-size: 14px;
}
.breakWord {
  word-break: break-word;
}
</style>
